export const getTabSecondaryLabelTestId = (testId: string) => `${testId}-secondary-label`;
